<template>
  <div>
    <PageTitle
      title="Features to help you grow"
      description="What can OutdoorManger do for your organisation?"
    />

    <div class="container">
      <b-row class="p-3">
        <b-col cols="3">
          <h3 class="text-dark">Operations</h3>
        </b-col>
        <b-col sm>
          <b-row cols-sm="3" align-v="stretch" class="p-n3">
            <d-col sm v-for="feature in features" :key="feature.id" class="p-3">
              <div class="h-100">
                <div class="d-flex h-100">
                  <div class="text-dark rounded-lg mr-3 my-auto">
                    <font-awesome-icon
                      :icon="feature.icon"
                      fixed-width
                      class="h3 p-0 m-0"
                    />
                  </div>
                  <div class="my-auto">
                    <div class="h5 text-primary">{{ feature.title }}</div>
                    <div class="mt-3 text-secondary">
                      <small>{{ feature.description }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </d-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle";

export default {
  components: {
    PageTitle
  },
  data() {
    return {
      features: [
        {
          id: 1,
          title: "Equipment",
          description: "Logging of equipment, equipment types and PPE checks.",
          icon: "toolbox"
        },
        {
          id: 2,
          title: "Activity Bases",
          description:
            "Logging of base checks such as monthly and yearly inspections.",
          icon: "layer-group"
        },
        {
          id: 3,
          title: "Vehicles",
          description:
            "Logging of MOT, Insurance and Tax details with reminders.",
          icon: "shuttle-van"
        },
        {
          id: 4,
          title: "Team",
          description:
            "Qualifications, Training, Activity Observations and Availability.",
          icon: "id-badge"
        },
        {
          id: 5,
          title: "Tasks",
          description:
            "Assign Tasks to users including links to other parts of the system.",
          icon: "thumbtack"
        },
        {
          id: 6,
          title: "Calendar",
          description:
            "Monthly and Weekly calendar showing important dates to keep organised..",
          icon: "calendar"
        }
      ]
    };
  }
};
</script>
